module.exports = __webpack_public_path__ + "img/search-salon-beauty-2020.9712d7d4.jpg";